// extracted by mini-css-extract-plugin
export default {"passwordStrength":"ResetPasword_passwordStrength__4+L9p","active":"ResetPasword_active__R5kfp"};